export enum NavigationSlugs {
    Main = 'main',
    MainLoggedIn = 'main.logged-in',
    MainBcm = 'main.bcm',
    MainAdmin = 'main.admin',
}
